module.exports = __webpack_public_path__ + "static/media/noAlerts.3bbc0bc7.png";